import ItineraryGenerationPage from '@/components/itinerary/ItineraryForm';

export default function CreateItineraryPage() {
  return (
      <ItineraryGenerationPage />
  );
}
